import Address from './Address.js'
export default
    class Garage {
    constructor(description, client_id, address_id) {
        this.description = description
        this.client_id = client_id
        this.address_id = address_id
        this.address = new Address()
    }
}